import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from "@angular/material/card";

@Component({
  selector: 'ui-lmiv-product-not-found',
  standalone: true,
  templateUrl: './lmiv-product-not-found.component.html',
  styleUrls: ['./lmiv-product-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ MatCardModule],
})
export class LmivProductNotFoundComponent {
}
